import "@/styles/main.scss";
/**
 * !(i)
 * Код попадает в итоговый файл, только когда вызвана функция, например FLSFunctions.spollers();
 * Или когда импортирован весь файл, например import "files/script.js";
 * Неиспользуемый код в итоговый файл не попадает.

 * Если мы хотим добавить модуль следует его раскомментировать
 */
// import MousePRLX from './libs/parallaxMouse'
// import AOS from 'aos'
// import Swiper, { Navigation, Pagination } from 'swiper';

import BaseHelpers from './helpers/base-helpers';
import PopupManager from './modules/popup-manager';
import BurgerMenu from './modules/burger-menu';
// import Tabs from './modules/tabs';
// import Accordion from './modules/accordion';
import SearchBar from './modules/search-bar';
import Splide from '@splidejs/splide';
import './modules/post-scroll';

BaseHelpers.checkWebpSupport();

BaseHelpers.addTouchClass();

BaseHelpers.addLoadedClass();

/**
 * Метод для зміни висоти підкладки під fixed хедер
 */
// BaseHelpers.headerFixed();
BaseHelpers.headerScrollUpTrigger();
BaseHelpers.placeholderReplacer();
BaseHelpers.creatorReplacer();
BaseHelpers.containerToggler();
BaseHelpers.splideChecker();
// BaseHelpers.containlessPostImages();
// BaseHelpers.navigationActive();
BaseHelpers.dynamicSectionExtractor();
BaseHelpers.floatingTooltips();
// BaseHelpers.specialNewsReplacer();
BaseHelpers.firstArticleExtractor();

/**
 * Открытие/закрытие модальных окон
 * Чтобы модальное окно открывалось и закрывалось
 * На окно повешай атрибут data-popup="<название окна>"
 * На кнопку, которая вызывает окно повешай атрибут data-type="<название окна>"

 * На обертку(.popup) окна добавь атрибут '[data-close-overlay]'
 * На кнопку для закрытия окна добавь класс '.button-close'
 * */
new PopupManager();

/**
 *  Модуль для работы с меню (Бургер)
 * */
new BurgerMenu().init();

/**
 *  Search in header module
 * */
new SearchBar().init();

/**
 *  Библиотека для анимаций
 *  документация: https://michalsnik.github.io/aos
 * */
// AOS.init();

/**
 * Параллакс мышей
 * */
// new MousePRLX();

document.addEventListener( 'DOMContentLoaded', function() {
	BaseHelpers.scrollIntoMobileNavActive();

	/**
	 * Splide .articles-category mobile sliders executer
	 */
	// const splideElms = document.querySelectorAll( '.articles-category-slider.splide' );

	// if (splideElms.length) {

	// 	for ( var i = 0; i < splideElms.length; i++ ) {
	// 		new Splide( splideElms[ i ], {
	// 			perPage: 1.2,
	// 			focus  : 0,
	// 			arrows : false,
	// 		} ).mount();
	// 	}

	// }

	/**
	 * Splide .main-articles mobile slider executer
	 */
	const mainSplide = document.querySelectorAll( '.main-articles-slider.splide' );

	if (mainSplide.length) {

		for ( let i = 0; i < mainSplide.length; i++ ) {
			new Splide( mainSplide[ i ], {
				// perPage   : 1.2,
				focus     : 0,
				arrows    : false,
				pagination: true,
			} ).mount();
		}

	}

	// const slidersWithThumbnails = document.getElementsByClassName('image-slider-with-thumbnails');

	// for (let i = 0; i < slidersWithThumbnails.length; i++ ) {
	// 	// const secondarySliderEl = slidersWithThumbnails[i].querySelector('.secondary-slider');
	// 	// const secondarySlider = new Splide( secondarySliderEl, {
	// 	// 	rewind      : true,
	// 	// 	fixedWidth  : 100,
	// 	// 	fixedHeight : 64,
	// 	// 	isNavigation: true,
	// 	// 	gap         : 10,
	// 	// 	focus       : 'center',
	// 	// 	pagination  : false,
	// 	// 	arrows		: false,
	// 	// 	cover       : true,
	// 	// 	breakpoints : {
	// 	// 		'600': {
	// 	// 			fixedWidth  : 66,
	// 	// 			fixedHeight : 40,
	// 	// 		}
	// 	// 	}
	// 	// } ).mount();

	// 	const primarySliderEl = slidersWithThumbnails[i].querySelector('.primary-slider');
	// 	const primarySlider = new Splide( primarySliderEl, {
	// 		type       : 'fade',
	// 		// autoHeight : true,
	// 		// heightRatio: 0.8,
	// 		rewind     : true,
	// 		// pagination : false,
	// 		arrows     : true,
	// 		cover      : true,
	// 	} );

	// // Set the thumbnails slider as a sync target and then call mount.
	// 	// primarySlider.sync( secondarySlider ).mount();
	// 	// post-page slider mount
	// 	primarySlider.mount();
	// }

	/**
	 * Tabs with attr data-tabs executer
	 */
	// const tabsElements = document.querySelectorAll('[data-tabs]');

	// if (tabsElements.length) {

	// 	tabsElements.forEach((tab) => {
	// 		const tabName = tab.getAttribute('data-tabs');

	// 		new Tabs(tabName, {
	// 			onChange: (data) => {
	// 				console.log(data);
	// 			},
	// 		});

	// 	});

	// }
} );

// new Accordion('.accordion', {
// 	shouldOpenAll: false, // true
// 	defaultOpen: [], // [0,1]
// 	collapsedClass: 'open',
// });
